import React, { useState } from "react";

function SeoSection() {
  const [isTextOpen, setTextOpen] = useState(false);

  return (
    <>
      <div className={"font-jost px-4 py-10 border border-black/12 rounded-2xl bg-white mb-6 lg:mb-5"}>
        <div
          className={`mb-4 transition-[max-height] duration-400 ease-in-out overflow-hidden text-gray-1 text-sm font-normal leading-5 lg:text-lg lg:leading-6 lg:max-w-[1032px] lg:mx-auto ${
            isTextOpen ? "max-h-[9999px]" : "max-h-[400px] lg:max-h-[192px]"
          }`}>
          {/*visible text start*/}
          <main className={"flex flex-col gap-4 lg:gap-6 mb-8 lg:mb-10"}>
            <div>
              Get ready to rev up your excitement with the ultimate chance to win big! Our{" "}
              <a
                href={"https://www.botb.com/prizes/cars"}
                title={"dream car giveaways"}
                className={"text-primary underline font-medium"}>
                dream car giveaways
              </a>{" "}
              and{" "}
              <a
                href={"https://www.botb.com/"}
                title={"car competitions"}
                className={"text-primary underline font-medium"}>
                car competitions
              </a>{" "}
              put you in the fast lane to{" "}
              <a href={"https://www.botb.com/"} title={"win a car"} className={"text-primary underline font-medium"}>
                win a car
              </a>{" "}
              you’ve always wanted — from powerful supercars to everyday favorites. Plus, with{" "}
              <a
                href={"https://www.botb.com/prizes/free-competition"}
                title={"free competitions"}
                className={"text-primary underline font-medium"}>
                free competitions
              </a>{" "}
              and{" "}
              <a
                href={"https://www.botb.com/prizes/2instantwin"}
                title={"instant win competitions"}
                className={"text-primary underline font-medium"}>
                instant win competitions
              </a>
              , the thrill of victory could be just a click away. Every entry brings you closer to that unforgettable
              moment when your dream ride becomes reality!
            </div>
            <div>
              But why stop there? Imagine unlocking the door to your{" "}
              <a
                href={"https://www.botb.com/win-a-house-uk"}
                title={"dream home"}
                className={"text-primary underline font-medium"}>
                dream home
              </a>{" "}
              or landing a life-changing cash prize. With opportunities to{" "}
              <a
                href={"https://www.botb.com/win-a-house-uk"}
                title={"win a house"}
                className={"text-primary underline font-medium"}>
                win a house
              </a>
              ,{" "}
              <a
                href={"https://www.botb.com/win-money"}
                title={"win money"}
                className={"text-primary underline font-medium"}>
                win money
              </a>
              , and take part in our biggest draws yet, your next big win could be right around the corner. Join the
              excitement, enter today, and with the{" "}
              <a
                href={"https://www.botb.com/botb-pass"}
                title={"BOTB Pass"}
                className={"text-primary underline font-medium"}>
                BOTB Pass
              </a>
              , you can take your chances even further, enjoying more entries, exclusive perks, and the thrill of
              winning every single month!
            </div>
          </main>
          {/*visible text end*/}

          <main>
            <section className={"flex flex-col mb-6 lg:mb-10"}>
              <div className={"text-primary text-lg leading-6 font-semibold mb-4 lg:mb-6 lg:text-[28px] lg:leading-8"}>
                What is the BOTB Pass?
              </div>
              <div className={"mb-8"}>
                <strong className={"text-dark-1 font-medium"}>The BOTB Pass</strong> is your all-access ticket to the
                thrill of winning! This exclusive subscription gives you a set number of monthly entries into our
                biggest prize draws — from Dream Cars and Luxury Homes to incredible Pick Your Prize, all at a
                discounted price. Choose from three exciting tiers:{" "}
                <strong className={"text-dark-1 font-medium"}>Essential</strong>,{" "}
                <strong className={"text-dark-1 font-medium"}>Premium</strong>, and{" "}
                <strong className={"text-dark-1 font-medium"}>Ultimate</strong>, each packed with entries and exclusive
                perks. With the BOTB Pass, you’ll enjoy unbeatable savings and keep the excitement of winning alive
                every single month!
              </div>
              <div>
                Choose from <strong className={"text-dark-1 font-medium"}>three exciting tiers</strong>, each designed
                to match your winning style:
              </div>
            </section>

            <section className={"mb-8 max-lg:flex max-lg:flex-col max-lg:gap-4 lg:grid lg:grid-cols-3 lg:mb-10"}>
              {/*#1*/}
              <div className={"max-lg:border-b border-black/8 pb-4 lg:pb-6 lg:pr-6"}>
                <div className={"text-dark-1 font-medium text-lg mb-2 lg:text-2xl lg:leading-7.5"}>Essential Pass:</div>
                <div>
                  Starting at just <strong className={"text-dark-1 font-medium"}>£9.99 per month</strong>, you’ll get{" "}
                  <strong className={"text-dark-1 font-medium"}>28 automatic entries</strong> into our main prize draws
                  every month. It’s the perfect way to stay in the game and enjoy regular chances to win — all at an
                  affordable price.
                </div>
              </div>

              {/*#2*/}
              <div className={"max-lg:border-b border-black/8 lg:border-l lg:border-r pb-4 lg:pb-6 lg:px-6"}>
                <div className={"text-dark-1 font-medium text-lg mb-2 lg:text-2xl lg:leading-7.5"}>Premium Pass:</div>
                <div>
                  Upgrade to this tier for <strong className={"text-dark-1 font-medium"}>£19.99 per month</strong> and
                  take your chances to the next level with{" "}
                  <strong className={"text-dark-1 font-medium"}>76 monthly entries</strong> — including{" "}
                  <strong className={"text-dark-1 font-medium"}>4 entries</strong> into the{" "}
                  <strong className={"text-dark-1 font-medium"}>£1.60 Dream Car Competition</strong>, featuring
                  higher-value prizes and top-tier vehicles. Designed for true enthusiasts, the Premium Pass gives you
                  enhanced rewards and a front-row seat to the most exciting draws every month.
                </div>
              </div>

              {/*#3*/}
              <div className={"lg:pl-6"}>
                <div className={"text-dark-1 font-medium text-lg mb-2 lg:text-2xl lg:leading-7.5"}>Ultimate Pass:</div>
                <div>
                  For the ultimate fans, our top-tier membership gives{" "}
                  <strong className={"text-dark-1 font-medium"}>209 monthly entries</strong> for{" "}
                  <strong className={"text-dark-1 font-medium"}>£43.99 per month</strong>, or save{" "}
                  <span className={"text-dark-1"}>up to 75%</span> with an annual subscription. Enjoy priority access,
                  premium perks for our most loyal players, and the chance to win legendary cars like{" "}
                  <strong className={"text-dark-1 font-medium"}>Porsche</strong>,{" "}
                  <strong className={"text-dark-1 font-medium"}>Lamborghini</strong>, and{" "}
                  <strong className={"text-dark-1 font-medium"}>Aston Martin</strong> — the ultimate way to experience
                  BOTB.
                </div>
              </div>
            </section>

            <section className={"flex flex-col lg:mb-10"}>
              <div className={"text-primary text-lg leading-6 font-semibold mb-4 lg:mb-6 lg:text-[28px] lg:leading-8"}>
                Exciting Winner Stories
              </div>
              <div className={"mb-8 lg:mb-6"}>
                Meet Khaja Syed from Birmingham — the very definition of “life‑changing win”. As a member of the BOTB
                Ultimate Pass, Khaja was automatically entered into every major draw. One of those entries turned into
                the biggest win we have ever announced: a luxury home in Saffron Walden worth{" "}
                <strong className={"text-dark-1 font-medium"}>£1.3 million</strong>.
              </div>
              <div className={"mb-2 lg:mb-6"}>In his own words, Khaja described the moment as:</div>
              <div className={"mb-8 lg:mb-10"}>
                “It felt like a miracle… a magical moment I just can’t express.” He decided to take the{" "}
                <strong className={"text-dark-1 font-medium"}>£1 million cash alternative</strong> (tax‑free) and is now
                clearing debts, supporting his children, and finally launching his own business.
              </div>
              <div>
                Thanks to his Ultimate Pass membership, Khaja didn’t have to pick and choose draws — they all entered
                for him. This win is a powerful reminder of how one membership tier can turn an ordinary moment into
                something truly life-changing.
              </div>
            </section>
          </main>
        </div>
        <div
          className={
            "text-primary mt-8 lg:mt-10 text-base font-normal text-center leading-5.5 cursor-pointer lg:text-xl lg:leading-6.5 underline"
          }
          onClick={() => {
            setTextOpen(prevState => !prevState);
          }}>
          {isTextOpen ? "Read less" : "Read more"}
        </div>
      </div>
    </>
  );
}

export default SeoSection;
